// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"4e420e47","531":"1d39710c","726":"56c05ec2","727":"f85e34da","967":"eb42a3f4"}[chunkId] + ".chunk.js";
};